/**
 * When modifying this array it's important to know that the order matters!
 * Complex (non-string) items should be at the bottom, as otherwise the restrictions may be
 * evaluated before the criteria definition!
 * (e.g. 'gravity' depends on 'crop' being ['crop', 'pad', 'thumb', 'fill'], but if 'gravity'
 * restrictions are evaluated before 'crop' is being defined, they will pass, but the image load
 * will fail)
 */
export default [
  'aspect_ratio',
  'zoom',
  'x',
  'y',
  'format',
  'fetch_format',
  'quality',
  'radius',
  'angle',
  'effect',
  'opacity',
  'border',
  'background',
  'overlay',
  'underlay',
  'default_image',
  'delay',
  'color',
  'color_space',
  'dpr',
  'page',
  'density',
  'flags',
  'transformation',
  'if',
  'variable',
  'type',
  'crop',
  'width',
  'height',
  'quality',
  {
    name: 'gravity',
    restrictions: [
      {
        name: 'crop',
        value: ['crop', 'pad', 'thumb', 'fill']
      }
    ]
  }
];
